(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[202],{

/***/ 59514:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal/signin",
      function () {
        return __webpack_require__(30723);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Signin; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var hooks_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22699);





function Signin() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,hooks_hooks__WEBPACK_IMPORTED_MODULE_3__/* .usePortal */ .vI)(), 1), pushPortal = ref[0];
    var ref1 = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.useSession)(), session = ref1.data;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (session) {
            pushPortal("/partners/".concat(session.partner.id, "/dashboard"));
        } else {
            (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.signIn)("keycloak", {
                callbackUrl: "/portal/callback"
            });
        }
    }, [
        session
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9872,2699,9774,2888,179], function() { return __webpack_exec__(59514); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);